module.exports = __webpack_public_path__ + "img/swiper_introduce_01.17073924.png";